import { post, postJson, get, deleteApiJson, putJson, put } from "./axios";

const RESOURCE_BASE_PATH = "/aggregateLink";
// 链接列表
export const aggregateLinkPage = (p) => postJson(`${RESOURCE_BASE_PATH}/activities/page`, p);
// 创建聚合链接
export const aggregateLinkCreate = (p) => postJson(`${RESOURCE_BASE_PATH}/create`, p);
// 聚合链接列表
export const aggregateLinkChange = (p) => postJson(`${RESOURCE_BASE_PATH}/page`, p);
// 删除聚合链接
export const aggregateLinkDelete = (p) => deleteApiJson(`${RESOURCE_BASE_PATH}/batch`, p);
// 聚合链接详情
export const aggregateLinkDetail = (p) => get(`${RESOURCE_BASE_PATH}/activities`, p);

//BI店铺礼包查询活动类型
export const biShopGiftTypes = (p) => get(`/giftBag/biShopGiftActivityTypes`, p);


